import { View, StyleSheet } from "react-native";
import ParksMapView from "../components/ParksMapView/ParksMapView";

export default function Parks() {
  return (
    <View testID="general-map-view" style={styles.screen} accessible={true} accessibilityLabel="Parks Map">
      <ParksMapView />
    </View>
  );
}
const styles = StyleSheet.create({
  screen: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});
